import React from 'react';
import styles from 'assets/css/Card.module.css';
import CoursePartials from "../Partials/Partials.Course";
import {LMSCourseCardComponent} from "../Components/LMSCourseCardComponent";
import { getImageSource } from 'utils/imgUtils';

function LMSCourseBundleCard(props) {
    //local var(s)
    const { LMSCourses: LMSCourses, UpgradeOption: UpgradeOption }  = props.data;

    //render
    return (
        <div className={styles.cardBodyDefault}>
            <div className="lmsCourseBundle-container">
                {
                    !!UpgradeOption
                    ?   <div className={styles.wrapper}>
                            {
                                !!UpgradeOption.UpgradeImage
                                ?
                                    <div className={styles.imgWrap}>
                                        <img src={getImageSource(UpgradeOption.UpgradeImage)}/>
                                    </div>
                                : <></>
                            }
                            <div className={styles.contentWrap}>
                                <CoursePartials.Upgrade upgradeText={UpgradeOption.UpgradeText} upgradeIcon={UpgradeOption.UpgradeIcon}/>
                                <CoursePartials.CardLink {...UpgradeOption} />
                            </div>
                        </div>
                    : LMSCourses.map(course => (<LMSCourseCardComponent course={course}/>))
                }
            </div>
        </div>
    )
}

export default LMSCourseBundleCard;